export enum AlertType {
  ERROR,
  SUCCESS,
}

export type AlertData = {
  message: string
  duration?: number
  type?: AlertType
}
